import {
  Component,
  signal,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FollowUpsUtilsService } from '@app/modules/follow-ups/services/follow-ups-utils.service';
import { GetSamplesListAction } from '@app/modules/service-data/store/sample.actions';
import { SampleState } from '@app/modules/service-data/store/sample.state';
import { LoadKitById } from '@core/store/kits/kits.actions';
import { KitsState } from '@core/store/kits/kits.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-follow-up-search',
  imports: [ReactiveFormsModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './follow-up-search.component.html',
})
export class FollowUpSearchComponent {
  private store = inject(Store);
  private followUpsUtils = inject(FollowUpsUtilsService);
  private modalRef = inject(NgbActiveModal);

  kitIdControl = new FormControl<string>('', [Validators.required]);
  loading = signal(false);

  close() {
    this.modalRef.close();
  }

  submit() {
    if (this.kitIdControl.valid) {
      const kitId = this.kitIdControl.value;
      this.loading.set(true);
      combineLatest([
        this.store.dispatch(new LoadKitById(kitId)).pipe(
          switchMap(() => this.store.select(KitsState.getKitById)),
          map((getKitById) => getKitById(kitId))
        ),
        this.store
          .dispatch(
            new GetSamplesListAction({ kitIds: [kitId] }, {}, null, true)
          )
          .pipe(
            switchMap(() => this.store.select(SampleState.getSampleByKitId)),
            map((getByKitId) => getByKitId(kitId))
          ),
      ])
        .pipe(first())
        .subscribe(([kit, sample]) => {
          const followUpIds = [
            ...(kit?.followUpIds ?? []),
            ...(sample?.followUpIds ?? []),
          ];
          this.followUpsUtils.openFollowUpsListDialog(followUpIds);
          this.close();
        });
    }
  }
}
